<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <!--data-aos="zoom-in"-->
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo d-inline-block">
                        <img src="assets/img/logo/white-logo.png" style="height:57px;" alt="image">
                    </a>
                    <div class="about-the-store">
                        <p>
                            {{'Footer_AboutTXT' | translate }}
                        </p>
                    </div>

                    <ul class="social-link">
                        <li><a href="https://www.instagram.com/amgadbookshop/" class="dblock" target="_blank" style="font-size:25px"><i class="fa-brands fa-instagram icon-color"></i></a></li>
                        <li><a href="https://www.youtube.com/@amgadbookshop8783/" class="dblock" target="_blank" style="font-size:25px"><i class="fa-brands fa-youtube icon-color"></i></a></li>
                        <li><a href="https://twitter.com/amgadbookshop" class="dblock" target="_blank" style="font-size:25px"><i class="fa-brands fa-twitter icon-color"></i></a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=100069768820670" class="dblock" target="_blank" style="font-size:25px"><i class="fa-brands fa-facebook-f icon-color"></i></a></li>
                    </ul>

                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6 col-6" >
                <div class="single-footer-widget pl-4">
                    <h3>
                        {{'Quick_Information' | translate }}
                    </h3>
                    <ul class="quick-links">
                        <li><a routerLink="/home">{{'Home' | translate }}</a></li>
                        <li><a routerLink="/about">{{'About_Us' | translate }}</a></li>
                        <li><a routerLink="/contact">{{'Contact_Us' | translate }}</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
                <div class="single-footer-widget">
                    <h3> {{'Shopping' | translate }}</h3>
                    <ul class="customer-support">
                        <li><a routerLink="/shop">{{'Shop' | translate }}</a></li>
                        <li><a routerLink="/cart">{{'Cart' | translate }}</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <!-- data-aos="fade-right"
    data-aos-offset="300"
    data-aos-easing="ease-in-sine"-->
                    <h3>{{'Stay_connected' | translate }}:</h3>

                    <!--data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"-->
                    <ul class="customer-support">
                        <li><i class="bx bx-map" style="margin-right:5px"></i> {{'Footer_Address' | translate }} </li>
                        <li><i class="bx bx-phone-call" style="margin-right:5px"></i> <a href="tel:+96897676711" dir="ltr">+968 97676711</a></li>
                        <li><i class="bx bx-message" style="margin-right:5px"></i> <a href="mailto:AMGADINTERNATIONALB@GMAIL.COM" style="font-size:x-small">AMGADINTERNATIONALB@GMAIL.COM</a></li>
                        <!--<li><i class="bx bx-time-five" style="margin-right:5px"></i> {{'Footer_Working_Hours' | translate }}</li>
                        <li><i style="margin-right:5px"></i> {{'Footer_Working_HoursFri' | translate }}</li>-->
                    </ul>
                </div>
            </div>

        </div>

        <div class="footer-bottom-area custom-margin">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p>Copyright 2026 Amgad All rights reserved | Powered By <a href="http://d-pioneers.com/" target="_blank">Digital Pioneers</a></p>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/privacy">{{'Privacy_Policy' | translate }}</a></li>
                        <li><a routerLink="/terms">{{'Terms_&_Conditions' | translate }}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!---div class="lines">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    </div-->
</footer>


<a class="go-whatsapp" href="https://wa.me/96897676711" target="_blank" style="background-color:forestgreen"><i class='bx bxl-whatsapp'></i></a>


